






































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import Checkbox from '@/modules/shared/components/shared/kit/Checkbox.vue'
import { PropSync } from 'vue-property-decorator'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import TagsInput from '@/modules/shared/components/shared/kit/TagsInput.vue'
import { InvoiceItemResourceModel } from '@/modules/invoice-item/models/invoice-item-resource.model'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import AdminInvoiceItemFormTable from '@/modules/invoice-item/components/admin/table/AdminInvoiceItemFormTable.vue'

@Component({
  components: {
    AdminInvoiceItemFormTable,
    BaseCard,
    Checkbox,
    CurrencyInput,
    Toggle,
    BaseSelect,
    BaseInput,
    TagsInput,
    PriceView
  }
})
export default class AdminInvoiceItemForm extends Vue {

  @PropSync('items', { required: true }) itemsSync!: InvoiceItemResourceModel[]

  get discountSum() {
    let sum = 0
    this.itemsSync.forEach((item, index) => {
      sum += item.discount
    })
    return sum
  }

  get payableSum() {
    let sum = 0
    this.itemsSync.forEach((item, index) => {
      sum += item.payable
    })
    return sum
  }

  addPeriod() {
    this.itemsSync.push({
      discount: 0, payable: 0, price: 0, quantity: 1, title: ''
    })
  }

}
